import React from 'react';
import PropTypes from 'prop-types';

import ConnectionLinkModal from './connection_link_modal';
import ConnectedRow from './connected_row';
import UnconnectedRow from './unconnected_row';

export default class ConnectableRow extends React.Component {
  static propTypes = {
    availableDatabaseOptions: PropTypes.array.isRequired,
    connectableObject: PropTypes.shape({
      connections: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })),
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired,
    onConnectEntities: PropTypes.func.isRequired,
    onCopyAndConnect: PropTypes.func.isRequired,
    onUnlink: PropTypes.func.isRequired
  }

  state = {
    editing: false
  }

  onLinkMore = () => {
    this.setState({ editing: true });
  }

  cancelEdit = () => {
    this.setState({ editing: false });
  }

  renderRow() {
    const connectableObject = this.props.connectableObject;

    if (connectableObject.connections.length > 0) {
      return (
        <ConnectedRow
          connectableObject={connectableObject}
          onLinkMore={this.onLinkMore}
          onUnlink={this.props.onUnlink}
        />
      );
    } else {
      return (
        <UnconnectedRow
          connectableObject={connectableObject}
          onLinkMore={this.onLinkMore}
        />
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderRow()}
        <hr/>
        <ConnectionLinkModal
          availableDatabaseOptions={this.props.availableDatabaseOptions}
          connectableObject={this.state.editing ? this.props.connectableObject : null}
          onConnectEntities={this.props.onConnectEntities}
          onCopyAndConnect={this.props.onCopyAndConnect}
          onHide={this.cancelEdit}
        />
      </React.Fragment>
    );
  }
}
